import React, { useEffect, useState } from "react";
import DashboardShell from "../../components/layout/DashboardShell";
import { Card, Pill, EmptyState } from "../../components/common/Primitives";
import api from "../../lib/api";

const tones = {
  "Expressed": "gold", "Query Sent": "warn", "Response Under Review": "warn",
  "Response Shared": "success", "Deal Room Opened": "success", "Closed": "muted", "Dropped": "danger",
};

export default function StartupInvestorInterest() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/startup/interests").then((r) => setRows(r.data || [])); }, []);

  return (
    <DashboardShell title="Investor Interest" subtitle="STARTUP · ATTENTION LOG">
      {rows.length === 0 ? (
        <EmptyState title="No investor interest yet" hint="When an approved investor expresses interest in your profile, it will appear here." />
      ) : (
        <div className="border border-white/10 bg-white/70 backdrop-blur">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-widest text-ink-muted border-b border-white/10">
                <th className="px-4 py-3">Investor</th>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3">At</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.interest_id} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 text-ink font-heading">{r.investor_name}</td>
                  <td className="px-4 py-3 text-ink-soft font-mono text-xs uppercase">{r.investor_type}</td>
                  <td className="px-4 py-3"><Pill tone={tones[r.status] || "muted"}>{r.status}</Pill></td>
                  <td className="px-4 py-3 text-ink-muted font-mono text-xs">{r.created_at?.slice(0, 10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </DashboardShell>
  );
}
